import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@ordr-as/icons'
import { ReactNode, useEffect, useRef, useState } from 'react'

const TruncatedItem = ({ children, label }: { children: ReactNode; label: string }) => {
    const [overflowActive, setOverflowActive] = useState(false)

    const contentRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const isOverflowActive = (node: HTMLDivElement | null) => {
            if (node) {
                console.log(node.offsetWidth, node.scrollWidth, node.offsetWidth < node.scrollWidth)
                return node.offsetWidth < node.scrollWidth
            }
        }

        return isOverflowActive(contentRef.current) ? setOverflowActive(true) : setOverflowActive(false)
    }, [overflowActive])

    return (
        <Disclosure>
            {({ open }) => (
                <div className="my-2">
                    <Disclosure.Button
                        className="flex justify-between w-full items-center"
                        as={overflowActive ? 'button' : 'div'}
                    >
                        <span
                            className={`${
                                overflowActive && open ? 'text-brand-primary' : ''
                            } transition-colors font-semibold`}
                        >
                            {label}
                        </span>
                        <div className="truncate ml-auto pl-3" ref={contentRef}>
                            {children}
                        </div>
                        {overflowActive && (
                            <div className="pl-3">
                                <ChevronDownIcon
                                    className={`${
                                        open ? 'transform rotate-180' : ''
                                    } transition-transform text-brand-primary`}
                                />
                            </div>
                        )}
                    </Disclosure.Button>
                    {overflowActive && (
                        <Disclosure.Panel>
                            <div className="whitespace-pre-wrap break-words border-l-2 border-brand-primary ml-2 mt-2 mb-4 pl-2">
                                {children}
                            </div>
                        </Disclosure.Panel>
                    )}
                </div>
            )}
        </Disclosure>
    )
}

export default TruncatedItem
